import { render, staticRenderFns } from "./PayMethods.vue?vue&type=template&id=56eb345b&"
import script from "./PayMethods.vue?vue&type=script&lang=js&"
export * from "./PayMethods.vue?vue&type=script&lang=js&"
import style0 from "./PayMethods.vue?vue&type=style&index=0&id=56eb345b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports